import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Tiny GET cache so mobile tab switches don't re-fetch on every visit.
 * Caches the in-flight promise (de-dupes concurrent calls) for `ttl` ms.
 * Mutations call `invalidate(substr)` to drop stale entries.
 */
const store = new Map(); // url -> { ts, promise }

export async function cachedGet(path, { ttl = 60000, force = false } = {}) {
  const url = path.startsWith('http') ? path : `${BACKEND_URL}${path}`;
  const hit = store.get(url);
  if (!force && hit && Date.now() - hit.ts < ttl) return hit.promise;
  const promise = axios.get(url, { withCredentials: true }).then((r) => r.data);
  store.set(url, { ts: Date.now(), promise });
  promise.catch(() => store.delete(url)); // let failures retry next time
  return promise;
}

export function invalidate(substr) {
  for (const key of Array.from(store.keys())) {
    if (!substr || key.includes(substr)) store.delete(key);
  }
}
